<template>
  <div class="py-16 border-bottom-stroke-dark-soft pl-16">
    <div class="grid-row d-flex_middle grid-row_sm">
      <div class="grid-col">
        <div class="icon-24">
          <img
            class="img-cover"
            src="./../../assets/images/logo-orteka.svg"
            alt="logo"
          />
        </div>
      </div>

      <div class="grid-col grid-col_full">
        <div class="fw-medium text-uppercase">ОРТЕКА</div>
      </div>

      <!-- <div class="grid-col">
        <div class="color-gray">21.11.2024</div>
      </div>-->
    </div>

    <div class="color-caption-soft mt-20" v-html="text"></div>
  </div>
</template>

<script>
export default {
  name: "answer",
  props: {
    text: {
      type: String,
      default:
        "добрый день! Очень приятно слышать, что вы остались довольны покупкой. Мы стараемся предоставлять только лучшие изделия и сервис для наших клиентов.",
    },
  },
};
</script>
